import './render-value.css';

const RenderValue = ({ value }) => (value ? value : '--');

export default RenderValue;

RenderValue.propTypes = {};
